import { Avatar } from '@nautilusbio/nb-design-system/Avatar';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import React, { type FC, memo } from 'react';

interface AvatarCellRendererProps {
  /** Display name shown in the avatar and tooltip */
  value: string;
}

/**
 * Cell renderer that displays a user's name as an avatar with a tooltip.
 * Used for created_by and updated_by columns.
 */
const AvatarCellRenderer: FC<AvatarCellRendererProps> = ({ value }) => (
  <Tooltip content={value} placement="right-start" trigger={<Avatar size="xs3">{value}</Avatar>} />
);

export default memo(AvatarCellRenderer);
